import {
  HttpContext,
  HttpContextToken,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpOptions } from '@mds/ngx-core';
import { catchError, throwError } from 'rxjs';
import { ErrorResponseHandlerService } from '../services/error-response-handler.service';

export const UseCustomErrorHandler = new HttpContextToken<boolean>(() => false);

export function useCustomErrorHandler(context?: HttpContext): HttpOptions {
  context ??= new HttpContext();
  context.set(UseCustomErrorHandler, true);
  return { context };
}

export const responseErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const handler = inject(ErrorResponseHandlerService);

  return next(req).pipe(
    catchError((errorResponse: HttpErrorResponse) => {
      if (!req.context.get(UseCustomErrorHandler)) {
        handler.handleResponse(errorResponse);
      }

      return throwError(() => errorResponse);
    }),
  );
};
